import React, { createContext } from 'react';

interface EmbedContextProps {
  embedIsReady: boolean;
  setEmbedIsReady: React.Dispatch<React.SetStateAction<boolean>>;
  contextChatbotUuid: string | null;
  setContextChatbotUuid: React.Dispatch<React.SetStateAction<string | null>>;
}

const EmbedContext = createContext<EmbedContextProps>({
  embedIsReady: false,
  setEmbedIsReady: () => {},
  contextChatbotUuid: null,
  setContextChatbotUuid: () => {}
});

export default EmbedContext;
